import AudioManager from "../../Shared/AudioManager";
import {Global} from "../../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class VistorLoginTips extends cc.Component {

    // @property(cc.Label)
    // label: cc.Label = null;
    //
    // @property
    // text: string = 'hello';
    start () {

    }

    onBtnUpgrade(){
        let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
        this.node.destroy();
    }

    onBtnClose(){
        AudioManager.playSound("close");
        cc.director.emit(Global.UserEvent.AfterLogin);
        this.node.destroy();
    }
}
